<script setup>
import { computed } from 'vue';
import { messageTimestamp } from 'shared/helpers/timeHelper';
import BaseBubble from './Base.vue';
import { useMessageContext } from '../provider.js';
import { emitter } from 'shared/helpers/mitt';
import wootConstants from 'dashboard/constants/globals';

const { conversationId, content, createdAt } = useMessageContext();

const isTransferActivity = computed(() => {
  if (!content.value) return false;
  const c = content.value.toLowerCase();
  const actionKeywords = ['atribuíd', 'assigned', 'desatribuíd', 'unassigned', 'remov', 'remove', 'designa'];
  return actionKeywords.some(ak => c.includes(ak));
});

const openTransferHistory = () => {
  emitter.emit('openTransferHistoryModal', conversationId.value);
};

const readableTime = computed(() =>
  messageTimestamp(createdAt.value, 'LLL d, h:mm a')
);
</script>

<template>
  <BaseBubble
    v-tooltip.top="readableTime"
    class="px-3 py-1 !rounded-xl flex min-w-0 items-center gap-2 group"
    data-bubble-name="activity"
  >
    <span v-dompurify-html="content" :title="content" />
    <button
      v-if="isTransferActivity"
      v-tooltip.top="'Ver histórico de transferências'"
      class="opacity-0 group-hover:opacity-100 transition-opacity cursor-pointer text-n-brand ml-1 border-0 bg-transparent p-0 flex items-center outline-none"
      @click.stop="openTransferHistory"
    >
      <fluent-icon icon="history" size="14" />
    </button>
  </BaseBubble>
</template>
